import { endOfMonth, format, parse } from "date-fns";
import { API_DATE_FORMAT } from "@constants";

interface IUpdateExpiryDateCardPayload {
    expirationDate: string;
}

export const getStateToPayload = (expiryMonthField: string, expiryYearField: string): IUpdateExpiryDateCardPayload => {
    const newExpiryDate = parse(`01/${expiryMonthField}/${expiryYearField}`, "dd/M/yyyy", new Date());

    return { expirationDate: format(endOfMonth(newExpiryDate), API_DATE_FORMAT) };
};
